export interface MatomoConfig {
  base: string;
  siteId: string;
}

type Command = unknown[];

declare global {
  interface Window {
    _paq?: Command[];
  }
}

const SCRIPT_ID = 'matomo-tracker';

// Reads the Matomo settings. Returns null when they do not give a server
// address and a numeric site ID, so the site sends no statistics.
export function matomoConfig(
  url: string | undefined | null,
  siteId: string | undefined | null,
): MatomoConfig | null {
  const base = (url || '').trim();
  const id = (siteId || '').trim();
  if (!/^https?:\/\/\S+$/.test(base) || !/^\d+$/.test(id)) return null;
  return { base: base.endsWith('/') ? base : `${base}/`, siteId: id };
}

function queue(): Command[] {
  window._paq = window._paq || [];
  return window._paq;
}

// Loads the Matomo tracker once. The tracker sets no cookies.
export function startMatomo({ base, siteId }: MatomoConfig): void {
  if (document.getElementById(SCRIPT_ID)) return;
  const paq = queue();
  paq.push(['disableCookies']);
  paq.push(['enableLinkTracking']);
  paq.push(['setTrackerUrl', `${base}matomo.php`]);
  paq.push(['setSiteId', siteId]);
  const script = document.createElement('script');
  script.id = SCRIPT_ID;
  script.async = true;
  script.src = `${base}matomo.js`;
  document.head.appendChild(script);
}

// Records a page view with the current document title.
export function trackPageView(url: string, referrer: string | null): void {
  const paq = queue();
  if (referrer) paq.push(['setReferrerUrl', referrer]);
  paq.push(['setCustomUrl', url]);
  paq.push(['setDocumentTitle', document.title]);
  paq.push(['trackPageView']);
}
